/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */

import { eventType } from './analyticsWebTypes';

export function isActionEventType(type: string): boolean {
	switch (type) {
		case eventType.OPERATIONAL:
		case eventType.TRACK:
		case eventType.UI:
			return true;
		default:
			return false;
	}
}
